import {
  GlobeKitView, PointGlobe, Points, Atmosphere, Background, GKUtils, CalloutManager, CalloutDefinition, gkweb_bg,
} from 'globekit-public';
import bg from "../assets/bg.png";
import gkweb_bg2 from "../assets/gkweb_bg.wasm";
import clouds from "../assets/clouds.png";
import disk from "../assets/disk.png";
import pointglobe from '../pointglobe.bin';
import { DataCallout } from './callout.js';

// Api Key from your GlobeKit account
const apiKey = 'gk_333af62dcde1dfc2e0af7d42070ddcf9ff594215db71fa14a3159bc5d50f358eb02e9b2b9d5d5d3bfa9939fa1816c43938ebbecb45dbb753e5fa19d6238f7122';

const textures = {
  noise: clouds,
};

const generateRandomGeoJson = () => {
  const geojson = {
    "type": "FeatureCollection",
    "features": [
    {
      "type": "Feature",
      "properties": {
        "pays": "Irlande",
        "name": "Irlande",
        "employees": "dublin",
        "mythicalCreatureSightings": Math.floor(Math.random() * 30),
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
        -73.80615234375,
        42.66628070564928
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "pays": "france",
        "name": "france",
        "mythicalCreatureSightings": Math.floor(Math.random() * 30),
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
        -97.734375,
        30.259067203213018
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "pays": "USA",
        "name": "Irlande",
        "mythicalCreatureSightings": Math.floor(Math.random() * 30),
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
        -6.2603097,
        53.3498053
        ]
      }
    }
    ]
  };

  return geojson;
};
const randomGeojson = generateRandomGeoJson();

class MyGlobeKit {
  constructor(canvas) {
    this.gkOptions = {
      apiKey,
      wasmPath: gkweb_bg2,
      clearColor: GKUtils.hexToRGBA("#000", 0),
      attributes: {
        alpha: true,
      },
    };

    this.gkview = new GlobeKitView(canvas, this.gkOptions);

    this.calloutManager = new CalloutManager(document.getElementById('callout-manager'));
    this.gkview.registerCalloutManager(this.calloutManager);
    // This gets called when the calloutManager removes a callout, i.e. when it rotates behind the globe.
    this.calloutManager.onAutoRemove = (def) => {
    };

    this.gkview.onSelection = (list) => {
      list.drawables.forEach((el) => {
        if (el.obj.id === this.points.id) {
          if (el.selection !== undefined) {
            const sel = el.selection[0][0];
            this.calloutManager.removeAllCallouts();

            this.calloutManager.addCallout(new CalloutDefinition(sel.lat, sel.lon, DataCallout, sel.properties));
            const element = document.querySelector('[data-pays="' + sel.properties.pays + '"]');

            element.scrollIntoView({behavior: "smooth", block: "center"});
          } else {
            this.calloutManager.removeAllCallouts();
          }
        }
      });
    };

    this.getNextLocation = () => {

      const loc = {
        "properties": {
          "pays": "USA",
          "name": "Irlande",
          "mythicalCreatureSightings": Math.floor(Math.random() * 30),
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
          -73.80615234375,
          42.66628070564928
          ]
        }
      };
      return {
        lat: loc.geometry.coordinates[1],
        lon: loc.geometry.coordinates[0],
        properties: loc.properties,
      };
    }

    this.setCallout = (properties) => {}

    this.goToNextLocation = () => {
      const loc = this.getNextLocation();
      const animationProps = {
        duration: 3000,
        onComplete: () => {
          // Remove any callouts
          this.calloutManager.removeAllCallouts();
          // Place callout defined by TourCallout at lat/lon with properties
          this.calloutManager.addCallout(new CalloutDefinition(loc.lat, loc.lon, DataCallout, loc.properties));
        },
      };

      // Turn off ambient motions
      this.gkview.ambientController.isEnabled = true;

      // Animate camera to location
      this.gkview.animationController.animateLatLonAlt(loc.lat, loc.lon, 3, animationProps);
    }

    const animationProps2 = {
        duration: 2000,
        onComplete: () => {
          // Remove any callouts
          this.calloutManager.removeAllCallouts();
          // Place callout defined by TourCallout at lat/lon with properties
        },
    };

    let hover = document.querySelectorAll(".menu__item");

    hover.forEach((e) => {
      e.addEventListener("mouseover", () => {
      // highlight the mouseover target
            this.goToNextLocation();


      }, false);
      e.addEventListener("mouseout", () => {
      // highlight the mouseover target
            this.gkview.animationController.animateAlt(4, animationProps2);


      }, false);
    })

    //setInterval(this.gkview.animationController.animateAlt(4), 3000);

    this.atmosphere = new Atmosphere({
      texture: disk,
    });
    this.atmosphere.nScale = 0;
    this.gkview.addDrawable(this.atmosphere);

    fetch(pointglobe)
    .then((res) => res.arrayBuffer())
    .then((data) => {
      const pointglobeParams = {
        pointSize: 0.006,
        randomPointSizeVariance: 5,
        randomPointSizeRatio: 5,
        minPointAlpha: 100,
        minPointSize: 5,
        color: '#000',
      };
      this.pointglobe = new PointGlobe(textures, data, pointglobeParams);
      this.pointglobe.setInteractive(true, true, true);
    })
    .then(() => {
      this.gkview.addDrawable(this.pointglobe, () => {
        this.gkview.startDrawing();
      });
      this.points = new Points();
      this.points.transform = (element, point) => {
        point.color = GKUtils.lerpColor('#ffffff', '#000000', 0.1);
        return point;
      };
      this.points.addGeojson(randomGeojson);
      this.points.setInteractive(true, true, false);
      this.gkview.addDrawable(this.points);
    });
  }
}

export { MyGlobeKit };
